import { ReportInterface } from '../../../interfaces/report.interface';

export class SubmitReport {
    public static readonly type = '[JobsPlacements] submit report';

    constructor(public report: ReportInterface) {}
}
